export default function Hero() {
  return (
    <section className="relative bg-[#1E3A47] overflow-hidden pt-12 md:pt-16">
      <div className="w-full flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px] max-w-[1280px] mx-auto">
        {/* Left text */}
        <div className="w-full lg:w-[55%] flex flex-col justify-center px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16">
          <div className="max-w-2xl">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-4 md:mb-6">
              Contactez DF PRO Réparation Fenêtre Strasbourg
            </h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed mb-6 md:mb-8">
              Devis gratuit sous 24h. Appelez-nous ou écrivez-nous.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="tel:0374471036"
                className="inline-flex items-center justify-center gap-2 bg-[#FF6B4A] text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-[#FF6B4A]/90 transition-colors"
              >
                <i className="ri-phone-line" />
                Appeler le 03 74 47 10 36
              </a>
              <a
                href="#devis"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors"
              >
                <i className="ri-edit-line" />
                Devis gratuit
              </a>
            </div>
          </div>
        </div>
        {/* Right image */}
        <div className="w-full lg:w-[45%] relative min-h-[280px] md:min-h-[400px] lg:min-h-0">
          <div className="absolute inset-0 m-4 md:m-6 lg:m-8 rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/270072d9fe20dda93c94f272f4415ced.jpeg"
              alt="Technicien DF PRO au téléphone"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A47]/40 to-transparent lg:hidden" />
          </div>
        </div>
      </div>
    </section>
  );
}